module.exports = __webpack_public_path__ + "static/image5-8711389434b3b82933219be3823abe05.jpg";